import { render, staticRenderFns } from "./PerformanceManager.vue?vue&type=template&id=9369a74e&scoped=true"
import script from "./PerformanceManager.vue?vue&type=script&lang=ts"
export * from "./PerformanceManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9369a74e",
  null
  
)

export default component.exports